import type React from 'react';
import { memo, type ReactNode } from 'react';
import {
  MainCheckboxCheckedIcon,
  MainCheckboxDisabledIcon,
  MainCheckboxUnCheckedIcon,
} from '@shared/assets/index';
import { SCheckBoxWrapper, SLabel } from '@shared/ui/inputs/iconCheckbox/styles';

export interface IconCheckboxPT
  extends Pick<
    React.InputHTMLAttributes<HTMLInputElement>,
    'className' | 'onClick' | 'disabled' | 'checked'
  > {
  label?: string;
  checkedIcon?: ReactNode;
  unCheckedIcon?: ReactNode;
  disabledIcon?: ReactNode;
  labelClassName?: string;
}

export const IconCheckbox: React.FC<IconCheckboxPT> = memo(
  ({
    label,
    checkedIcon,
    unCheckedIcon,
    disabledIcon,
    checked,
    disabled,
    labelClassName,
    ...props
  }) => {
    const renderedCheckedIcon = checkedIcon || <MainCheckboxCheckedIcon />;
    const renderedUnCheckedIcon = unCheckedIcon || <MainCheckboxUnCheckedIcon />;
    const renderedDisabledIcon = disabledIcon || <MainCheckboxDisabledIcon />;

    return (
      <SCheckBoxWrapper disabled={disabled} {...props}>
        {disabled && renderedDisabledIcon}

        {!disabled && (checked ? renderedCheckedIcon : renderedUnCheckedIcon)}

        {label && (
          <SLabel $checked={checked} className={labelClassName}>
            {label}
          </SLabel>
        )}
      </SCheckBoxWrapper>
    );
  }
);
